import React from 'react';
import { Box, Chip, Tooltip, useTheme } from '@mui/material';
import { string } from 'prop-types';

// Styles
import { toolTipStyles, toolTipWrapperStyles } from '../Security.styles';

const TableToolTip = ({ color, name, acronym }) => {
  const theme = useTheme();

  return (
    <Tooltip enterTouchDelay={10} placement="bottom" title={name}>
      {/* Need to wrap empty div to get tooltip working */}
      <Box sx={toolTipWrapperStyles(theme)}>
        <Chip
          label={acronym}
          sx={{
            ...toolTipStyles,
            '& .MuiChip-label': {
              marginTop: '1px',
              padding: 0,
            },
            '&:first-of-type': {
              marginRight: theme.spacing(0.5),
            },
            alignItems: 'center',
            bgcolor: color,
            borderRadius: '4px',
            display: 'flex',
            height: 20,
            justifyContent: 'center',
            padding: '2px',
            width: 30,
          }}
        />
      </Box>
    </Tooltip>
  );
};

TableToolTip.propTypes = {
  acronym: string.isRequired,
  color: string.isRequired,
  name: string.isRequired,
};

export default TableToolTip;
